var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#F8FAFC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z","key":0}),React.createElement("path",{"stroke":"#F8FAFC","strokeWidth":"1.5","d":"M3 16V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5Z","key":1}),React.createElement("path",{"stroke":"#F8FAFC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"m17.5 6.51.01-.011","key":2})]);
}

Instagram.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Instagram;

Instagram.default = Instagram;
